import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { ActiveSecurityContextStateService } from '@security/active-security/active-security-context.state-service';
import { TopNavigationLink } from '@app/app-layout/header/product-navigation/navigation-bar/navigation-bar';
import { FeatureFlagService, FeatureFlagsServiceInjectionToken } from '@feature-flags/feature-flag.service';
import { BehaviorSubject } from 'rxjs';
import { getBureauNavigationLinks } from '@app/app-layout/header/product-navigation/bureau-navigation/bureau-navigation-links';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bureau-navigation',
  templateUrl: './bureau-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: []
})
export class BureauNavigationComponent {
  bureauLinksBehaviorSubject: BehaviorSubject<TopNavigationLink[]> = new BehaviorSubject<TopNavigationLink[]>([]);
  bureauLinks$ = this.bureauLinksBehaviorSubject.asObservable();

  constructor(
    private activeSecurity: ActiveSecurityContextStateService,
    private router: Router,
    @Inject(FeatureFlagsServiceInjectionToken) public featureFlagService: FeatureFlagService
  ) {
    this.bureauLinksBehaviorSubject.next(
      getBureauNavigationLinks(
        this.activeSecurity.activeBureau,
        this.activeSecurity,
        this.router,
        this.featureFlagService
      ) as TopNavigationLink[]
    );
  }
}
